import React from 'react';
import { AppStore } from '../../AppStore';
import { PathwordStore } from '../_puzzles/Pathword/PathwordStore';
import StarIcon from '@mui/icons-material/Star';
import OutcomeBanner from './OutcomeBanner';

const PathwordPreview = ({ onClick }: { onClick: () => void }) => {
  const pathwordData = AppStore.useState(s => s.puzzleData?.pathword);
  if (!pathwordData) return null;

  const matrix = pathwordData.vowelMatrix;

  return (
    <div className="previewTile puzzleTile" onClick={onClick}>
      <div className="puzzleTitle">Pathword</div>
      <div className="matrixPreviewContainer">
        <div className="matrixGrid">
          <div className="goldStar"><StarIcon/></div>
          {matrix.map((row, rowIndex) => (
            <div key={rowIndex} className="matrixRow">
              {row.map((letter, columnIndex) => (
                <div className={`previewGridCell ${letter ? '' : 'grey'}`} key={columnIndex}/>
              ))}
            </div>
          ))}
        </div>
        <OutcomeBanner store={PathwordStore as any} />
      </div>
    </div>
  );
};

export default PathwordPreview;